import React from "react";
import { Button, InputGroup, FormControl } from "react-bootstrap";
import { inject, observer } from "mobx-react";

import { SearchResultsList } from "../search/SearchResultsList";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";

@inject("searchStore", "http", "navigatorStore", "detailViewStore")
@observer
export class FrameworksList extends React.Component {
  render() {
    const {
      getFrameworks,
      getMetadata,
      getSearchFrameworkExpression,
      setSearchFrameworkExpression,
    } = this.props.searchStore;
    const {
      getFrameworkListLabel,
      getCurrentFrameworkListDisplayType,
      switchCurrentFrameworkListDisplayType,
      frameworkListDisplayType,
      getFrameworkListLabelForBurgerMenu,
    } = this.props.navigatorStore;
    const { isBurgerMenu } = this.props;
    return (
      <div className="link-group">
        <div className="descriptive-metadata custom-panel">
          <div className="custom-panel-heading reference">
            {!isBurgerMenu ? (
              <h4>{getFrameworkListLabel || "Frameworks"}</h4>
            ) : (
              <h4>{getFrameworkListLabelForBurgerMenu || "Frameworks"}</h4>
            )}
          </div>
        </div>

        {/* <div className="search-results-list">{selectedFramework}</div> */}
        {/* <h3
          style={{ fontWeight: "bold", color: "#003299", marginBottom: "15px" }}
        ></h3> */}
        {getMetadata && getFrameworks ? (
          Object.keys(getMetadata).length && getFrameworks.length ? (
            <>
              <InputGroup className="input-group-framework-search">
                <FormControl
                  placeholder="Search Framework by Name"
                  value={getSearchFrameworkExpression}
                  onChange={(e) => setSearchFrameworkExpression(e.target.value)}
                />
                <InputGroup.Button>
                  <Button onClick={() => setSearchFrameworkExpression("")}>
                    Clear
                  </Button>
                </InputGroup.Button>
                {IS_BIRD_APP && (
                  <div style={{ marginLeft: "20px" }}>
                    <InputGroup.Button>
                      <Button
                        onClick={() => switchCurrentFrameworkListDisplayType()}
                      >
                        {getCurrentFrameworkListDisplayType ===
                        frameworkListDisplayType.UNPUBLISHED
                          ? "BIRD Frameworks"
                          : "non-BIRD Frameworks"}
                      </Button>
                    </InputGroup.Button>
                  </div>
                )}
              </InputGroup>
              <div
                className="frameworks-container"
                style={{ overflowY: "scroll" }}
              >
                <SearchResultsList
                  hidePagination={true}
                  isHomePage={true}
                  isBurgerMenu={isBurgerMenu ? true : false}
                />
              </div>
            </>
          ) : (
            <div>There are no frameworks matching your chosen profile.</div>
          )
        ) : (
          <div>Loading...</div>
        )}
      </div>
    );
  }
}
